export const BusinessImprovementPlanUrls = {
    GENERAL_DATA: "/business-plan/general-data",
    LIST_OF_BUSINESS_PLANS: "/business-plan/list-of-plans",
    BUSINESS_PLAN_DETAILS: "/business-plan/{businessPlanId}",
    GET_BUSINESS_PLAN_REPORT: "/business-plan/download-business-plan/{businessPlanId}",
    GET_OBJECTIVE_DETAILS: "business-plan-objectives/view-objective/{objectiveId}",
};